"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BRIGHTNESS_DEGREE = exports.B_DEGREE = exports.G_DEGREE = exports.R_DEGREE = void 0;
exports.R_DEGREE = 0.299;
exports.G_DEGREE = 0.587;
exports.B_DEGREE = 0.114;
exports.BRIGHTNESS_DEGREE = 127.5;
